export const iconFontAwesomeMapsEyeLowVision = (
	<i className="fa-solid fa-eye-low-vision"></i>
);
